import { SvgIcon, SvgIconProps } from '@mui/material'

export const PinListIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'neutral500' }} {...props}>
    <path
      d="M15.39 6v2h7V6h-7Zm0 5v2h7v-2h-7Zm-9 5v2h16v-2h-16Zm-1.31-4.5c-.44-.68-.69-1.5-.69-2.39 0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5-2 4.5-4.5 4.5c-.87 0-1.69-.25-2.38-.68L3.39 16 2 14.61l3.08-3.11Zm3.81.11c1.38 0 2.5-1.11 2.5-2.5s-1.12-2.5-2.5-2.5a2.5 2.5 0 0 0 0 5Z"
      fill="inherit"
    />
  </SvgIcon>
)
